import { render } from "./TeacherTabs.vue?vue&type=template&id=a12a0c0c&ts=true"
import script from "./TeacherTabs.vue?vue&type=script&lang=ts"
export * from "./TeacherTabs.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__